import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { AppRouteOutlet } from "@/components/layout/AppRouteOutlet";
import Sidebar from "./Sidebar";
import Header from "./Header";
import { WorkspaceModeBanner } from "./WorkspaceModeBanner";
import { useSidebarCollapsed } from "@/hooks/useSidebarCollapsed";
import { DRAWER_WIDTH, DRAWER_WIDTH_COLLAPSED } from "@/theme/crmTheme";
function AppShell() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { collapsed, toggleCollapsed } = useSidebarCollapsed();
  const location = useLocation();
  const drawerWidth = collapsed ? DRAWER_WIDTH_COLLAPSED : DRAWER_WIDTH;
  useEffect(() => {
    setSidebarOpen(false);
  }, [location.pathname]);
  const drawerPaperSx = {
    width: drawerWidth,
    boxSizing: "border-box",
    transition: "width 0.2s ease",
    overflowX: "hidden",
  };
  return (
    <Box
      sx={{
        display: "flex",
        minHeight: "100vh",
        bgcolor: "background.default",
      }}
    >
      <Drawer
        variant="temporary"
        open={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
        ModalProps={{ keepMounted: true }}
        sx={{
          display: { md: "none" },
          "& .MuiDrawer-paper": { ...drawerPaperSx, width: DRAWER_WIDTH },
        }}
      >
        <Sidebar onNavigate={() => setSidebarOpen(false)} />
      </Drawer>
      <Drawer
        variant="permanent"
        sx={{
          display: { xs: "none", md: "block" },
          width: drawerWidth,
          flexShrink: 0,
          "& .MuiDrawer-paper": drawerPaperSx,
        }}
        open
      >
        <Sidebar collapsed={collapsed} onToggleCollapsed={toggleCollapsed} />
      </Drawer>
      <Box
        component="section"
        sx={{
          flex: 1,
          minWidth: 0,
          display: "flex",
          flexDirection: "column",
          minHeight: "100vh",
        }}
      >
        <Header
          onMenuClick={() => setSidebarOpen(true)}
          drawerWidth={drawerWidth}
        />
        <Box sx={{ flex: "1 0 auto", mt: { xs: "60px", md: "68px" } }}>
          <WorkspaceModeBanner />
          <Box
            component="main"
            sx={{
              flexGrow: 1,
              minWidth: 0,
              overflowX: "hidden",
              p: { xs: 1.25, sm: 2.5, md: 3.5 },
              bgcolor: "background.default",
              minHeight: "calc(100vh - 68px)",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <AppRouteOutlet />
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
export { AppShell as default };
